import * as TypeGraphQL from "type-graphql";
export var EventScalarFieldEnum;
(function (EventScalarFieldEnum) {
    EventScalarFieldEnum["id"] = "id";
    EventScalarFieldEnum["eventId"] = "eventId";
    EventScalarFieldEnum["timestamp"] = "timestamp";
    EventScalarFieldEnum["category"] = "category";
    EventScalarFieldEnum["eventType"] = "eventType";
    EventScalarFieldEnum["severity"] = "severity";
    EventScalarFieldEnum["source"] = "source";
    EventScalarFieldEnum["symbol"] = "symbol";
    EventScalarFieldEnum["accountId"] = "accountId";
    EventScalarFieldEnum["tradeId"] = "tradeId";
    EventScalarFieldEnum["signalId"] = "signalId";
    EventScalarFieldEnum["orderId"] = "orderId";
    EventScalarFieldEnum["userId"] = "userId";
    EventScalarFieldEnum["aggregateId"] = "aggregateId";
    EventScalarFieldEnum["aggregateType"] = "aggregateType";
    EventScalarFieldEnum["version"] = "version";
    EventScalarFieldEnum["eventData"] = "eventData";
    EventScalarFieldEnum["metadata"] = "metadata";
    EventScalarFieldEnum["signature"] = "signature";
    EventScalarFieldEnum["retentionPolicyId"] = "retentionPolicyId";
    EventScalarFieldEnum["retentionExpiresAt"] = "retentionExpiresAt";
    EventScalarFieldEnum["archived"] = "archived";
    EventScalarFieldEnum["tags"] = "tags";
    EventScalarFieldEnum["createdAt"] = "createdAt";
    EventScalarFieldEnum["updatedAt"] = "updatedAt";
})(EventScalarFieldEnum || (EventScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(EventScalarFieldEnum, {
    name: "EventScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=EventScalarFieldEnum.js.map